import styled from 'styled-components';
import { config } from '@keytrade/functions';
import { Title as TitleSC } from '@keytrade/components-title';
import { Paragraph as ParagraphSC } from '@keytrade/components-paragraph';
import { Span as SpanSC } from '@keytrade/components-span';
import { Badge as BadgeSC } from '@keytrade/components-badge';

import Image from '@/components/Image';
import { mediaQuery } from '@/utils/helpers';

const { list: colors } = config.colors;
const { getFont } = config.fonts;

export const ImageWrapper = styled.div<{ isPlaceholder?: boolean }>`
  position: relative;
  display: flex;
  flex-shrink: 0;
  width: 8.2rem;
  aspect-ratio: 4/4;
  margin-right: 2.4rem;
  border-radius: 6px;
  overflow: hidden;

  ${mediaQuery.md(`
  aspect-ratio: 4/3;
    width: 9.2rem;
  `)}

  ${mediaQuery.lg(`
  aspect-ratio: 4/3;
    width: 13.2rem;
  `)}

  ${({ isPlaceholder }) =>
    isPlaceholder &&
    `
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${colors.White};
      background-color: ${colors.BlueDark};
    `};

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: transparent;
    opacity: 0.5;
    z-index: 1;
    transition: background-color 0.2s ease-in;
  }
`;

export const Thumbnail = styled(Image)`
  object-fit: cover;
  width: 100%;
`;

export const Img = styled.img`
  object-fit: cover;
  width: 100%;
`;

export const PlayIcon = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4.8rem;
  width: 4.8rem;
  background-color: ${colors.BlackTransparent};
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.2s ease-in;
`;

export const Length = styled(SpanSC)`
  position: absolute;
  left: 4px;
  bottom: 4px;
  font-family: ${({ theme }) => getFont(theme, 'bold')};
  color: ${colors.White};
  font-size: 1.1rem;
  padding: 2px 4px;
  background-color: ${colors.BlackTransparent};
  border-radius: 4px;
  z-index: 1;

  ${mediaQuery.md(`
    left: 8px;
    bottom: 8px;
    font-size: 1rem;
  `)}
`;

export const ContentWrapper = styled.div`
  width: 100%;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  ${mediaQuery.lg(`
    flex-direction: row;
  `)}
`;

export const Title = styled(TitleSC)`
  color: ${(props) => colors[props.color]} !important;
`;

export const TagsWrapper = styled(SpanSC)`
  display: flex;
  margin-top: 5px;

  ${mediaQuery.lg(`
    margin-left: 2rem;
  `)}
`;

export const LanguageTag = styled(BadgeSC)`
  font-family: ${({ theme }) => getFont(theme, 'bold')};
  color: ${(props) => (props.isDark ? colors.White : colors.BlueDark)};
  background-color: ${(props) =>
    props.isDark ? colors.GreyBlue : colors.GreyWhite};
  border-color: ${(props) =>
    props.isDark ? colors.GreyBlue : colors.GreyWhite};
  letter-spacing: 0.6px;
  margin-right: 0.8rem;
`;

export const FeaturedTag = styled(LanguageTag)`
  color: ${colors.White};
  background-color: ${colors.GreenSeafoam};
`;

export const Description = styled(ParagraphSC)`
  ${mediaQuery.md(`
    display: block;
    margin: 8px 0 0;
  `)}

  ${mediaQuery.lg(`
    margin: 4px 0 0;
  `)}
`;

export const Media = styled.article<{
  isFeatured?: boolean;
  dark?: boolean;
  isMobile?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 1.4rem;
  transition: background-color 0.2s ease-in;
  cursor: pointer;
  ${({ isMobile, isFeatured }) =>
    isMobile &&
    isFeatured &&
    `
  ${Heading} {
    flex-direction: row;
  }

  `}
  ${mediaQuery.md(`
    padding: 2rem;
  `)}

  ${({ isMobile, isFeatured }) =>
    !isMobile &&
    isFeatured &&
    `
    padding: 0;
    align-items: initial;
    min-height: 24rem;

    ${mediaQuery.md(`
      padding: 0;
    `)}

    ${ImageWrapper} {
      width: 32rem;
      height: auto;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    ${ContentWrapper} {
      padding: 3.2rem 2.4rem 3.2rem 0;
    }

    ${Heading} {
      flex-direction: column;
      align-items: flex-start;
    }

    ${TagsWrapper} {
      margin: 0.8rem 0 0.8rem;
    }
  `};

  &:hover {
    background-color: ${({ dark }) => (dark ? '#3A4C57' : colors.BlueSmoke)};
    ${ImageWrapper}::before {
      background-color: #a9bac4;
    }

    ${PlayIcon} {
      opacity: 1;
    }
  }

  a {
    all: unset;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
    }
  }
`;
